/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{SnappingCandidate as t}from"./SnappingCandidate.js";class e extends t{constructor({coordinateHelper:t,targetPoint:e,objectId:o,constraint:n,elevationInfo:r}){super(t,e,n,r),this.objectId=o}}export{e as FeatureSnappingCandidate};
